import { render, staticRenderFns } from "./BaseClickedCheckbox.vue?vue&type=template&id=5659383e&scoped=true&"
import script from "./BaseClickedCheckbox.vue?vue&type=script&lang=ts&"
export * from "./BaseClickedCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./BaseClickedCheckbox.vue?vue&type=style&index=0&id=5659383e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5659383e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconCheckGray: require('/usr/www/nuxt/components/Icon/IconCheckGray.vue').default,IconCheck: require('/usr/www/nuxt/components/Icon/IconCheck.vue').default})
